import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const PathUsersRemove = connect(state => ({
  messages: state.messages,
  pageState: state.pageState
}))(class extends Component {
  remove = async () => {
    const { userId, pageState: { path }, updateUsers } = this.props;
    await api.delete(`/admin/paths/${path.id}/users?userId=${userId}`);
    await updateUsers({showLoading: false});
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonRemove}
        buttonIcon="trash-alt"
        buttonText={messages.commonRemoveUser}
        category="danger"
        confirmText={messages.pathsUsersRemoveConfirm}
        confirmTitle={messages.commonRemoveUser}
        onConfirm={this.remove}
        successMessage={messages.commonRemoveUserSuccess}
        stopPropagation={true}
      />
    );
  }
});

export default PathUsersRemove;
